// extracted by mini-css-extract-plugin
module.exports = {"forgot_password_message":"Message_forgot_password_message__1RdGc","icon":"Message_icon__ywphw","error_icon":"Message_error_icon__2Zj4k","info_icon":"Message_info_icon__1hH9s"};